import useMyPudoHome from './my-pudo-home.controller';

const ID = 'my-pudo-home';
export interface MyPudoHomeProps {}

const MyPudoHome = (props: MyPudoHomeProps) => {
    const viewProps = useMyPudoHome(props);

    return <div id={ID}>hello world from my pudo</div>;
};

export default MyPudoHome;
